// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { PopupProvider } from "./contexts/PopupContext";

window.addEventListener("unhandledrejection", (e) => {
  console.error("UNHANDLED PROMISE REJECTION:", e.reason);
});

window.addEventListener("error", (e) => {
  console.error("UNCAUGHT ERROR:", e.error || e.message);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
window.__NZ_BOOT_STARTED_AT__ = Date.now();

root.render(
  <React.StrictMode>
    <AuthProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();